import React from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import { useMediaQuery } from 'react-responsive'

import {
  fonts,
  mediaQueries,
  palette,
  setOpacity,
} from '../../styles/variables'

import EnterpriseUserModal from './EnterpriseUserModal'

Modal.setAppElement('body')
Modal.defaultStyles.overlay.backgroundColor = setOpacity(palette.pureBlack, 0.7)
Modal.defaultStyles.overlay.zIndex = '1000'

const defaultDesktopStyle = {
  position: 'initial',
  height: 'fit-content',
  borderRadius: '4px',
  border: 'none',
  padding: 0,
  width: '550px',
}

const defaultMobileStyle = {
  position: 'initial',
  height: '100%',
  borderRadius: 0,
  border: 'none',
  padding: 0,
  width: '100%',
}

const defaultOverlayStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: '100vh',
}

export const ModalHeader = styled.div((props) => ({
  padding: props?.padding || '40px 40px 0px 40px',
  fontSize: '24px',
  lineHeight: '24px',
  fontFamily: fonts.primaryBook,
  textAlign: 'center',
  position: 'relative',

  ':after': {
    content: `''`,
    borderBottom: props.noBorder ? '' : '1px solid red',
    width: (() => {
      if (props.after?.width) {
        return props.after.width
      }

      if (props.doubleBorder) {
        return '90px'
      }
      return props.noBorder ? '0px' : '45px'
    })(),
    display: props.noBorder ? 'none' : 'block',
    margin: props?.after?.margin || '24px auto auto',
  },
  [mediaQueries.mobile]: {
    fontSize: '20px',
  },
}))

export const ModalContent = styled.div(({ styles, maxWidth, padding }) => ({
  padding: padding || '40px 40px',
  maxWidth: maxWidth ? '95vw' : '100vw',
  [mediaQueries.tablet]: {
    padding: '30px 15px',
    maxWidth: '100vw',
  },
  ...(styles || {}),
}))

export const ModalFooter = styled.div(({ padding }) => ({
  padding: padding || '40px 40px',
  textAlign: 'center',
  borderTop: `1px solid ${palette.lightGray50}`,

  '& button': {
    minWidth: '170px',
    [mediaQueries.mobile]: {
      minWidth: '125px',
      flex: 1,
    },
  },

  '& button + button': {
    marginLeft: '24px',
    [mediaQueries.mobile]: {
      marginLeft: 0,
      marginTop: '15px',
    },
  },

  [mediaQueries.mobile]: {
    padding: '30px 20px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}))

export const RowContent = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const ColContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export default ({
  children,
  overlayStyle = {},
  desktopStyle = {},
  mobileStyle = {},
  isEnterpriseUser = false,
  mobileMaxWidth = 767,
  ...rest
}) => {
  const isMobile = useMediaQuery({ maxWidth: mobileMaxWidth })
  const defaultContentStyle = !isMobile
    ? defaultDesktopStyle
    : defaultMobileStyle
  const overridingContentStyle = !isMobile ? desktopStyle : mobileStyle
  if (isEnterpriseUser && rest?.isOpen) {
    return <EnterpriseUserModal {...rest} overlayStyle={overlayStyle} />
  }
  return (
    <Modal
      style={{
        overlay: {
          ...defaultOverlayStyle,
          ...overlayStyle,
        },
        content: {
          ...defaultContentStyle,
          ...overridingContentStyle,
        },
      }}
      {...rest}
    >
      {children}
    </Modal>
  )
}
